import styled from 'styled-components'
import createStyles from '@mui/styles/createStyles'
import makeStyles from '@mui/styles/makeStyles'
import { StyledButton } from 'components/shared/Button/Button.style'

interface IUseStyles {
  maxWidth: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | false
  overflowY: 'auto' | 'visible' | 'hidden'
}

export const useStyles = makeStyles(theme =>
  createStyles({
    paper: {
      background: theme.colors.white,
      boxShadow: theme.boxShadows.greyLight,
      borderRadius: 12,
      padding: '20px 8px 16px',
      width: '100%',
      overflowY: ({ overflowY }: IUseStyles) => overflowY,

      [theme.breakpoints.up(1024)]: {
        padding: '40px 64px 64px',
        margin: 0,
        maxWidth: 'calc(100% - 16px) !important',
        width: ({ maxWidth }: IUseStyles) => {
          switch (maxWidth) {
            case 'sm':
              return 500
            default:
              // md
              return 592
          }
        },
      },
    },
  })
)

export const CloseModal = styled(StyledButton)`
  position: absolute;
  right: 24px;
  top: 24px;
`
